import {
    ActionPointInfo,
    IActionPointInfo,
    IMiddleware,
    Middleware,
    IStopAction,
    StopAction,
} from '@tencent/workbench';
import { SLIDE_ADAPTER } from '../editor-adpater/slide-adapter';
import { renderCallBack } from '@com/top-menu/top-menu-action';
import { PREFIX } from '@framework/workbench/schema/menu-schema/common';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

const getMenuManager = (): IMenuManager | undefined => ((AppServiceProvider.getInstance()
    .getAppServices() as IPcEditorAppServices).editableServiceLayer?.menuManager);

/**
 * disabled中间件
 */
@Middleware({
    adapters: [SLIDE_ADAPTER],
})
export class TopMenuDisabledMiddleware implements IMiddleware {
    public use(@ActionPointInfo() info: IActionPointInfo) {
        let id = info.name;
        if (info.name.indexOf(PREFIX) !== -1) {
            id = info.name.replace(PREFIX, '');
        }
        const configs = renderCallBack(id, getMenuManager());

        return configs.disable;
    }
}

/**
 * hide 中间件
 */
@Middleware({
    adapters: [SLIDE_ADAPTER],
})
export class TopMenuHideMiddleware implements IMiddleware {
    public use(@ActionPointInfo() info: IActionPointInfo, @StopAction() stop: IStopAction) {
        const configs = renderCallBack(info.name, getMenuManager());

        if (configs.visible === false) {
            stop();
            return true;
        }
    }
}
